import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCookie, reloadWindow } from '../../Helpers/Utils';
import Handler from "../../Helpers/Components/Handler";
import Select from 'react-select'
import { PhoneInput } from "react-international-phone";
import DatePicker from "react-multi-date-picker";
import Creatable from 'react-select/creatable';

const Add = (props) => {
    const [newUser, setNewUser] = useState({ registerDate: new Date(), valid: true });
    const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}');
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const validPhoneNumber = /^[6-9][0-9]{9}$/;
    const person = getCookie('person')
    const [loading, setLoading] = useState(false)
    const [subadmin, setSubadmin] = useState([])
    const phoneOptions = [
        { label: "9566280480 - 6280", value: "9566280480" },
        { label: "9566180480 - 6180", value: "9566180480" },
    ]
    const options = [
        { label: "DC", value: "DC" },
        { label: "EC", value: "EC" },
        { label: "WA", value: "WA" },
        { label: "LC", value: "LC" },
        { label: "Walk-in", value: "Walk-in" },
        { label: "Ref", value: "Ref" },
        { label: "Other", value: "Other" }
    ]
    const handleNewChange = (e) => setNewUser(prev => ({ ...prev, [e.target.name]: e.target.value }))
    const onSubmit = async () => {
        if (!newUser?.src) {
            toast.error("Invalid Source");
        } else if (newUser?.src === "WA" && !newUser?.srcNumber) {
            toast.error("Whatsapp Source Number is required")
        } else if (newUser?.src === "DC" && !newUser?.srcNumber) {
            toast.error("DC Source Number is required")
        } else if ((newUser?.src === "DC" || newUser?.src === "WA") && !validPhoneNumber.test(newUser?.srcNumber)) {
            toast.error("DC Source Number is invalid")
        } else if (newUser?.src !== "LC" && newUser.code === "+91" && !validPhoneNumber.test(newUser?.phone)) {
            toast.error("Invalid Phone Number");
        } else if (newUser?.src !== "LC" && (!newUser?.phone || newUser.phone?.length <= 5)) {
            toast.error("Invalid Phone Number");
        } else if (newUser?.name && !validName.test(newUser?.name)) {
            toast.error("Invalid Name");
        } else if (newUser?.email && !validEmail.test(newUser?.email)) {
            toast.error("Invalid Email");
        } else if (newUser?.src === "Other" && !newUser.srcName) {
            toast.error("Invalid Source Name");
        } else {
            const data = { type: newUser?.type || "local", src: newUser?.src === "Other" ? newUser.srcName : newUser.src, registerDate: newUser?.registerDate || newUser?.createdAt, valid: newUser?.valid }
            if (newUser?.phone) { data['phone'] = newUser?.phone }
            if (newUser?.code) { data['code'] = newUser?.code }
            if (newUser?.name) { data['name'] = newUser?.name }
            if (newUser?.name) { data['name'] = newUser?.name }
            if (newUser?.address) { data['address'] = newUser?.address }
            if (newUser?.email) { data['email'] = newUser?.email }
            if (newUser?.src === "WA" || newUser?.src === "DC") { data['srcNumber'] = newUser?.srcNumber }
            if (newUser?.followedBy) { data['followedBy'] = newUser?.followedBy }
            setLoading(true)
            let method = props?.detail ? "patch" : "post"
            let url = props?.detail ? `/lead/update/${props?.detail?.leadId}` : `/lead/create`
            const response = await Handler({ method, url, data })
            if (response?.success) {
                toast.success(response?.message);
                setTimeout(reloadWindow, 2000);
            } else {
                setLoading(false)
                toast.error(response?.message || "Invalid values");
            }
        }
    };
    const handlePhoneChange = (e) => {
        let code = e[0]
        let phone = ""
        e.slice(1,).map(val => val ? val?.replace("-", "") : "").forEach(num => {
            phone += num;
        })
        setNewUser((prev) => ({ ...prev, phone, code }))
        if (code === "+91") {
            setNewUser((prev) => ({ ...prev, type: "local" }))
        } else {
            setNewUser((prev) => ({ ...prev, type: "nri" }))
        }
    }
    const getSubadmin = async () => {
        const response = await Handler({ method: 'GET', url: `/booking/lead-list` })
        if (response?.success) {
            setSubadmin(response.data?.length ? response.data?.map(element => { return { label: element.name, value: element.leadId } }) : [])
        } else {
            setSubadmin([])
        }
    }
    useEffect(() => {
        setNewUser({ registerDate: new Date(), valid: true });
        getSubadmin()
    }, []);
    useEffect(() => {
        if (props?.detail) {
            const details = props?.detail
            const other = options.find(element => element.value === details.src)
            setNewUser({ ...details, src: other?.value ? other.value : 'Other', srcName: other?.value ? other.value : details.src, code: details.code || "", number: details?.number })
        } else {
            setNewUser({ name: "", email: "", phone: "", address: "", type: "local", code: "", number: "", registerDate: new Date(), valid: true })
        }
    }, [props?.detail])
    return (
        <div className="row justify-content-center my-4">
            <div className="col-md-8">
                <form className="formSection">
                    <div className="mb-3">
                        <label className="form-label">Type</label>
                        <div className="d-flex gap-4">
                            <div className="form-check">
                                <input autoComplete='off' className="form-check-input" type="radio" name="custType" id="local" checked={newUser?.type === "local"} onChange={(e) => { if (e.target.checked) { setNewUser((prev) => ({ ...prev, type: "local" })) } }} />
                                <label className="form-check-label" htmlFor="local">
                                    Local
                                </label>
                            </div>
                            <div className="form-check">
                                <input autoComplete='off' className="form-check-input" type="radio" name="custType" id="nri" checked={newUser?.type === "nri"} onChange={(e) => { if (e.target.checked) { setNewUser((prev) => ({ ...prev, type: "nri" })) } }} />
                                <label className="form-check-label" htmlFor="nri">
                                    NRI
                                </label>
                            </div>
                            <div className="form-check">
                                <input autoComplete='off' className="form-check-input" type="radio" name="custType" id="foreigner" checked={newUser?.type === "foreigner"} onChange={(e) => { if (e.target.checked) { setNewUser((prev) => ({ ...prev, type: "foreigner" })) } }} />
                                <label className="form-check-label" htmlFor="foreigner">
                                    Foreigner
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Source</label>
                        <Select
                            value={newUser?.src ? { label: newUser?.src, value: newUser?.src } : ""}
                            onChange={(e) => { setNewUser((prev) => ({ ...prev, src: e?.value, srcNumber: "" })) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={options} className="mb-3" />
                    </div>
                    {
                        newUser?.src === "WA" || newUser?.src === "DC" ?
                            <div className="mb-3">
                                <label className="form-label">Source Number</label>
                                <Creatable
                                    value={newUser?.srcNumber ? phoneOptions?.find(ele => ele.value === newUser?.srcNumber) : ""}
                                    onChange={(selected) => { setNewUser((prev) => ({ ...prev, srcNumber: selected?.value })) }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    isValidNewOption={(inputValue) => { return /^\d+$/.test(inputValue); }}
                                    isClearable
                                    isDisabled={loading}
                                    options={phoneOptions} className="mb-3" />
                            </div>
                            : ""
                    }
                    {
                        newUser?.src === "Other" ?
                            <div className="mb-3">
                                <label className="form-label">Source Name</label>
                                <input autoComplete='off' type="text" disabled={loading} className="form-control input-theme" name="srcName" value={newUser?.srcName || ""} onChange={handleNewChange} placeholder="Enter Source Name" />
                            </div>
                            : ""
                    }
                    <div className="mb-3">
                        <label className="form-label">Register Date</label>
                        <div className=" datepicker-top" > <DatePicker format="DD/MM/YYYY" value={newUser?.registerDate || newUser?.createdAt} minDate={new Date(new Date(new Date()?.setDate(new Date()?.getDate() - 1))?.setHours(new Date(new Date()?.setDate(new Date()?.getDate() - 1))?.getHours() - 1))} maxDate={new Date(new Date()?.setHours(new Date()?.getHours() + 1))} onChange={(e) => { setNewUser(prev => ({ ...prev, registerDate: new Date(e) })) }} /></div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input autoComplete='off' type="text" disabled={loading} className="form-control input-theme" name="name" value={newUser?.name || ""} onChange={handleNewChange} placeholder="Enter name" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        {/* <input autoComplete='off' onPaste={handlePaste} disabled={(props?.detail && person !== "admin") || loading} type="text" className="form-control input-theme" name="phone" value={newUser?.phone || ""} maxLength={10} onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleNewChange(e) } }} placeholder="Enter Phone Number" /> */}
                        <PhoneInput
                            defaultCountry="in"
                            disabled={(props?.detail?.phone?.length && person !== "admin") || loading}
                            value={newUser?.phone ? (newUser?.code + newUser?.phone) : ""}
                            onChange={(phone, metadata) => { handlePhoneChange(metadata?.inputValue?.split(" "), 1) }}
                            onPaste={(e) => {
                                e.preventDefault();
                                let pasteData = e.clipboardData.getData('Text');
                                pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
                                setNewUser((prev) => ({ ...prev, phone: pasteData, code: e[0] }))
                                if (e[0] === "+91") {
                                    setNewUser((prev) => ({ ...prev, type: "local" }))
                                } else {
                                    setNewUser((prev) => ({ ...prev, type: "nri" }))
                                }
                            }}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Followed By</label>
                        <Select
                            value={newUser?.followedBy && subadmin?.length ? subadmin?.filter(element => element.value === newUser?.followedBy) : ""}
                            onChange={(e) => { setNewUser((prev) => ({ ...prev, followedBy: e?.value })) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading || (props?.detail && person !== "admin")}
                            options={subadmin} className="mb-3 text-capitalize" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Address</label>
                        <textarea className="form-control input-theme" disabled={loading} name="address" value={newUser?.address || ""} onChange={handleNewChange} placeholder="Enter Address" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input autoComplete='off' type="text" disabled={loading} className="form-control input-theme" name="email" value={newUser?.email || ""} onChange={handleNewChange} placeholder="Enter Email ID" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Valid Lead</label>
                        <div className="d-flex align-items-center gap-3">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="radioDefault" id="radioDefault1" checked={newUser?.valid} onChange={(e) => { setNewUser((prev) => ({ ...prev, valid: e.target.checked ? true : false })) }} />
                                <label className="form-check-label" htmlFor="radioDefault1"> Valid </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="radioDefault" id="radioDefault2" checked={!newUser?.valid} onChange={(e) => { setNewUser((prev) => ({ ...prev, valid: e.target.checked ? false : true })) }} />
                                <label className="form-check-label" htmlFor="radioDefault2"> Invalid </label>
                            </div>
                        </div>
                    </div>
                </form>
                <button className="btn btn-outline-success mt-3 w-100" disabled={loading} onClick={onSubmit}>Submit</button>
            </div>
        </div>
    );
};

export default Add;
